import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import VideoSection from './components/VideoSection';
import About from './components/About';
import Performances from './components/Performances';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ContactPopup from '../../components/feature/ContactPopup';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className={`transition-colors duration-300 ${scrolled ? 'text-black' : 'text-white'}`}>
                THOMAS
              </span>
            </div>
            
            <div className="hidden md:flex items-center gap-8">
              <button 
                onClick={openPopup}
                className={`text-sm font-medium transition-colors duration-300 hover:text-red-600 cursor-pointer ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                About
              </button>
              <button 
                onClick={openPopup}
                className={`text-sm font-medium transition-colors duration-300 hover:text-red-600 cursor-pointer ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                Performances
              </button>
              <Link
                to="/corporate-mice"
                className={`text-sm font-medium transition-colors duration-300 hover:text-red-600 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                Corporate & MICE
              </Link>
              <button 
                onClick={openPopup}
                className={`text-sm font-medium transition-colors duration-300 hover:text-red-600 cursor-pointer ${
                  scrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                Contact
              </button>
            </div>

            <button 
              onClick={openPopup}
              className="px-6 py-2.5 bg-red-600 text-white text-sm font-semibold rounded-full hover:bg-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-600/50 whitespace-nowrap cursor-pointer"
            >
              Book Now
            </button>
          </div>
        </div>
      </nav>

      <Hero onBookClick={openPopup} />
      <VideoSection />
      <About />
      <Performances onBookClick={openPopup} />
      <CTA onBookClick={openPopup} />
      <Footer onLinkClick={openPopup} />

      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
}
